import { Entity } from '@data-client/rest';
import type { BannerMessage } from '@axiom/validation';

/**
 * Hand-written Data Client entity for banner messages.
 *
 * Banner messages are served by the legacy Node `api` (client domain) and are
 * not part of any dark-roast OpenAPI spec, so this entity is not generated
 * (and intentionally lives outside `api/generated`). There is no `id` — one
 * banner per app — so the normalized cache is keyed by `appName` via `pk()`.
 */
export class BannerMessageEntity extends Entity {
  appName: BannerMessage['appName'] = 'envoy';

  backgroundColor: string | null = null;

  isActive: boolean | null = null;

  html: string | null = null;

  textColor: string | null = null;

  createdAt: string | null = null;

  updatedAt: string | null = null;

  static override key = 'BannerMessage';

  override pk() {
    return this.appName;
  }
}
